import axios from 'axios'

// 根据环境变量动态设置API URL
const getBaseUrl = () => {
  // 生产环境
  if (process.env.NODE_ENV === 'production') {
    return '/api'; // 使用相对路径，由后端服务器处理
  }
  // 开发环境
  return process.env.VUE_APP_API_URL || '/api';
};

// 输出当前API URL，便于调试
console.log('当前环境:', process.env.NODE_ENV);
console.log('当前API URL:', getBaseUrl());

const service = axios.create({
  baseURL: getBaseUrl(),
  timeout: 10000
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log('发送请求:', config.url)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.error('API请求错误:', error)
    if (error.response) {
      console.error('错误状态码:', error.response.status)
      console.error('错误数据:', error.response.data)
    }
    return Promise.reject(error)
  }
)

export default service 